import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`bg-${_ctx.bgColor}`, { 'custom-icon': _ctx.isCustom }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('click')))
  }, [
    _createVNode(_component_q_icon, {
      class: _normalizeClass(["s-icon hovered", [_ctx.size, { animated: _ctx.animated }]]),
      name: _ctx.name,
      color: _ctx.color
    }, {
      default: _withCtx(() => [
        (_ctx.isVisibleTooltip)
          ? (_openBlock(), _createBlock(_component_q_tooltip, {
              key: 0,
              "content-class": "s-tooltip",
              delay: _ctx.DELAY_TOOLTIP
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
              ]),
              _: 1
            }, 8, ["delay"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "badge")
      ]),
      _: 3
    }, 8, ["class", "name", "color"])
  ], 2))
}